import React from "react";

import { Button } from "~/components/button";
import { DragHandle } from "~/components/drag-and-drop/handle";
import { IconDragHandle } from "~/components/icon";
import { Tooltip } from "~/components/tooltip";
import { TooltipContent } from "~/components/tooltip/content";
import { TooltipTrigger } from "~/components/tooltip/trigger";

export type VariableDragHandleProps = React.ComponentProps<typeof Button>;

export const VariableDragHandle: React.FC<VariableDragHandleProps> = (props) => (
	<Tooltip disableHoverableContent>
		<TooltipTrigger>
			<DragHandle asChild>
				<Button asChild icon size="xs" variant="neutral" {...props}>
					<span>
						<IconDragHandle className="text-grey-500" />
					</span>
				</Button>
			</DragHandle>
		</TooltipTrigger>
		<TooltipContent>Drag to reorder</TooltipContent>
	</Tooltip>
);
